import type { GridValidRowModel } from "@mui/x-data-grid-premium";
import type { GridColDef } from "src/components/DataGrid/DataGrid.tsx";
import type { GridSortModel } from "@mui/x-data-grid/models";

export const prepareSortModel = <
  Row extends GridValidRowModel = GridValidRowModel,
>(
  sortModel: GridSortModel,
  columns: GridColDef<Row>[],
): GridSortModel => {
  return sortModel.map((item) => {
    const column = columns.find((column) => item.field === column.field);

    return {
      field: column?.backendSortName ?? item.field,
      sort: item.sort,
    };
  });
};
